import request from '@/utils/request'
request.defaults.headers.common['isToken'] = true
export function uploadImage(data) {
  return request({
    url: '/common/upload',
    method: 'post',
    data
  })
}


export function uploadContext(data) {
  return request({
    url: '/articles/articles',
    method: 'post',
    data
  })
}


